<template>
  <div class="!m-0 divider pt-3"><hr class="!m-0" /></div>
  <div class="p-6 tile-grid-photos gap-1 mt-3">
    <InspirationTiles
      :selected-image-state="props.selectedImageState"
      :templates="currentForegroundInspirations()"
      :is-loading="isLoading"
      :image-button-size="buttonSize"
    />
  </div>
  <div class="pb-3"></div>
</template>

<script lang="ts" setup>
import Client from "@/modules/internal_api/client";
import { MagicBackgroundForegroundType } from "@/modules/internal_api/magic_backgrounds";
import { withExponentialBackoff } from "@/modules/utils";
import { useEditorStore } from "@/stores/editor_store";
import { PersistentStore } from "@/stores/persistent_store";
import { computed, onMounted, ref } from "vue";
import InspirationTiles from "@/components/prism/inspiration_tiles.vue";
import { useMonitorSize } from "@/composables/monitor_size";

export interface InspirationGalleryProps {
  selectedImageState: PersistentStore;
  foregroundType: string;
}

const props = defineProps<InspirationGalleryProps>();
const store = useEditorStore();

const isLoading = ref(false);
const inspirations = computed(() => store.magicBackgrounds.inspirations);

const { isMobile } = useMonitorSize();

const buttonSize = computed(() => (isMobile.value ? "default" : "lg"));

onMounted(async () => {
  const allInspirations = await loadInspirations();
  store.loadInspirations(allInspirations);
});

const loadInspirations = async () => {
  try {
    isLoading.value = true;
    const templatesByType = await withExponentialBackoff(
      () => Client.fetchMagicBackgroundsTemplates({ foregroundType: props.foregroundType }),
      {
        on: [Error],
        retryLimit: 1,
      }
    );
    return templatesByType;
  } catch (err) {
    console.log(err);
  } finally {
    isLoading.value = false;
  }
};

const currentForegroundInspirations = () =>
  inspirations.value?.[props.foregroundType as MagicBackgroundForegroundType] || [];
</script>

<style lang="scss" scoped>
.tile-grid-photos {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  padding: 0 0.25rem;

  @media (min-width: 376px) and (max-width: 767px) {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}

.divider {
  margin: 0 -16px !important;

  @media (min-width: 640px) {
    margin: 0 -24px !important;
  }
}
</style>
